import { render, staticRenderFns } from "./tierDiscount.vue?vue&type=template&id=5f8301ab&scoped=true&"
import script from "./tierDiscount.vue?vue&type=script&lang=ts&"
export * from "./tierDiscount.vue?vue&type=script&lang=ts&"
import style0 from "./tierDiscount.vue?vue&type=style&index=0&id=5f8301ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8301ab",
  null
  
)

export default component.exports